import React, { useEffect, useState } from 'react';
import { Row } from 'antd';
import { IGetApiType } from '../../REST';
import { useRouterStore } from '../../hooks';
import { abortSelectedFetch, cleanInvoiceStore, getInvoiceById } from '../../middleware';
import { Catcher } from '../Catcher';
import { ShowInvoice } from './Components';
import Styles from '../styles/m_itemCardStyles.less';

export const Invoice: React.FC = () => {
    const usedApiTypes: IGetApiType[] = ['GET_COMPANIES_HIERARCHY'];
    const routerStore = useRouterStore();
    const [id, setId] = useState('');

    const goOut = (): void => {
        abortSelectedFetch(usedApiTypes);
        cleanInvoiceStore();
    };

    const goToList = (): void => {
        routerStore.goTo('InvoicesList');
        goOut();
    };

    const _getCountry = async (id: string): Promise<void> => {
        const isItem = await getInvoiceById(id);
        if (!isItem) {
            goToList();
        }
    };

    useEffect(() => {
        return (): void => {
            goOut();
        };
    }, []);

    useEffect(() => {
        if (id) {
            _getCountry(id);
        }
    }, [id]);

    useEffect(() => {
        if (routerStore.routerState.params.id) {
            setId(routerStore.routerState.params.id);
        }
    }, [routerStore.routerState.params.id]);

    return (
        <Catcher>
            <article className={Styles.main}>
                <Row>
                    <ShowInvoice />
                </Row>
            </article>
        </Catcher>
    );
};
